import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2.25 13.5V12H6.75V13.5H2.25ZM2.25 9.75V8.25H11.25V9.75H2.25ZM2.25 6V4.5H15.75V6H2.25Z" }, null, -1)
  ]))]))
}
export default { render: render }